import { IMAGES } from "../data/content";

const PhoneMockup = ({ caption, tilt = "left" }) => (
  <div data-testid="rnb-app-phone-mockup" className="group relative mx-auto w-[240px] sm:w-[280px]" style={{ perspective: "1200px" }}>
    <div
      className="rounded-[2.6rem] border border-zinc-700/80 bg-zinc-900 p-2 transition-transform duration-700 ease-out"
      style={{
        transform: tilt === "left" ? "rotateY(-16deg) rotateX(4deg)" : "rotateY(16deg) rotateX(4deg)",
        boxShadow: tilt === "left" ? "40px 40px 80px -20px rgba(0,0,0,0.9)" : "-40px 40px 80px -20px rgba(0,0,0,0.9)",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "rotateY(0deg) rotateX(0deg)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = tilt === "left" ? "rotateY(-16deg) rotateX(4deg)" : "rotateY(16deg) rotateX(4deg)")}
    >
      <div className="relative overflow-hidden rounded-[2rem] aspect-[9/19] bg-black">
        <img src={IMAGES.mockup} alt="Vista previa de la App RNB" className="h-full w-full object-cover object-top opacity-70" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-black/40" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 mt-2 h-5 w-24 rounded-full bg-black/90 border border-zinc-800" />
        <div className="absolute inset-x-0 bottom-0 p-5 space-y-3">
          <p className="font-display text-2xl tracking-wider text-white leading-none">APP RNB</p>
          <div className="space-y-2">
            <div className="h-2 w-3/4 bg-zinc-700/80" />
            <div className="h-2 w-1/2 bg-zinc-800/80" />
            <div className="h-2 w-2/3 bg-zinc-800/80" />
          </div>
          <p className="text-[10px] tracking-[0.3em] text-zinc-400 uppercase">{caption}</p>
        </div>
        <div className="absolute top-10 right-3 rotate-3 bg-white text-black text-[10px] font-bold tracking-[0.2em] px-3 py-1.5">
          PRÓXIMAMENTE
        </div>
      </div>
    </div>
    <div className="absolute -inset-4 -z-10 rounded-[3rem] bg-white/5 blur-2xl" aria-hidden="true" />
  </div>
);

export default PhoneMockup;
